import { useTheme } from 'styled-components';
import { Test } from '../../../2_domain/test/test';
import Column from '../../core/components/box/column';
import Row from '../../core/components/box/row';
import SizedBox from '../../core/components/box/sizedBox';
import LXMiddleButton from '../../core/components/buttons/lxMiddleButton';
import { LXbody, LXh3 } from '../../core/texts/lxText';
import LXLanguageSelector from '../../core/components/buttons/lxLanguageSelector';
import useTestDetailPageController from '../../../1_application/test/testDetailPageController';
import LXPlainSelector from '../../core/components/buttons/lxPlainSelector';

interface TestDownloadDialogProps {
  test: Test;
  language: Language;
  plain: plain;
  onGoBack: () => Promise<void>;
  onDownload: (value: string, plain: boolean) => Promise<void>;
}

export const TestDownloadDialog = (props: TestDownloadDialogProps) => {
  const theme = useTheme();
  const c = useTestDetailPageController(props.test);
  return (
    <Column justifyContent="space-between" alignItems="center">
      <SizedBox height={30}></SizedBox>
      <LXh3>{theme.texts.testResultPDF}</LXh3>
      <SizedBox height={30}></SizedBox>
      <Row alignItems="center">
        <LXbody color={theme.colors.caption}>{'Language :'}</LXbody>
        <SizedBox width={4}></SizedBox>
        <LXLanguageSelector
          value={c.lang.value}
          onSelect={c.setLang}
        ></LXLanguageSelector>
        <SizedBox width={20}></SizedBox>
        <Row alignItems="center">
          <LXbody color={theme.colors.caption}>{'Plain :'}</LXbody>
          <SizedBox width={4}></SizedBox>
          <LXPlainSelector
            value={c.plain}
            onSelect={c.setPlains}
          ></LXPlainSelector>
        </Row>
      </Row>
      <SizedBox height={40}></SizedBox>
      <Row justifyContent="center">
        <LXMiddleButton onClick={props.onGoBack} kind={'secondary'}>
          {theme.texts.goBack}
        </LXMiddleButton>
        <SizedBox width={8}></SizedBox>
        <LXMiddleButton onClick={async () => props.onDownload(c.lang, c.plain)}>
          {theme.texts.testResultPDFDownload}
        </LXMiddleButton>
      </Row>
    </Column>
  );
};
